import React, { Fragment } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Container, Row, Table, Spinner } from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';
import Flatpickr from "react-flatpickr";

import { createDeepClone } from "../utils/index";

import CardLoader from "../components/CardLoader";
import PaginationComponent from "../components/PaginationComponent";
import MySearchOption from "../components/MySearchOption";
import MyDateRenderer from "../components/MyDateRenderer";
import MyDateDisplay from "../components/MyDateDisplay";
import CustomerCategoryLabel from "../components/CustomerCategoryLabel";

import { useDispatch, useSelector } from "react-redux";
import * as isoRequestActions from "../actions/IsoRequestActions";

const IsoRequestNotifySearchScreen  = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const loading = useSelector((state) => state.iso.loading);
    const list = useSelector((state) => state.iso.notifyList);
    const filter = useSelector((state) => state.iso.notifyFilter);
    
    const doSearch = () => {
        var copy_filter = createDeepClone(filter);
        
        if(copy_filter.pageIndex == 1) {
            dispatch(isoRequestActions.loadIsoRequestNotifySearch(filter, navigate));
        }
        else {
            copy_filter.pageIndex = 1;
            dispatch(isoRequestActions.setIsoRequestNotifyFilter(copy_filter));
        }
    }

    React.useEffect(() => {
		dispatch(isoRequestActions.loadIsoRequestNotifySearch(filter, navigate));
    }, [filter.pageIndex]);

    const onFilterChange = (name, value) => {
        var copy_filter = createDeepClone(filter);
        copy_filter[name] = value;
        dispatch(isoRequestActions.setIsoRequestNotifyFilter(copy_filter));
    }

    const onPageChange = (page) => {
        var copy_filter = createDeepClone(filter);
        copy_filter.pageIndex = page;
        dispatch(isoRequestActions.setIsoRequestNotifyFilter(copy_filter));
    }

    const exportToExcel = () => {
        dispatch(isoRequestActions.downloadIsoRequestNotifySearch(filter, "ISO Certificates.xlsx"));
    }
    
    return(
        <Fragment>
            <div className="page-content">
            <Container fluid>
                    <BreadCrumb title="ISO Tickets to Expire Search" />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-3">
                                        <Col xxl={4} md={12}>
                                            <MySearchOption
                                                placeholder={"Search for ISO Tickets to Expire..."}
                                                value={filter.search}
                                                searchList={list.searchList || []}
                                                fieldName="search"
                                                onChange={onFilterChange}
                                            />
                                        </Col>
                                        <Col xxl={2} md={12}>
                                            <select className="form-select"
                                                value={filter.state}
                                                onChange={e => onFilterChange("state", e.target.value)}
                                            >
                                                <option value={"Upcoming"}>Upcoming</option>
                                                <option value={"Expired"}>Expired</option>
                                            </select>
                                        </Col>
                                        <Col xxl={2} md={12}>
                                            <select className="form-select"
                                                value={filter.dateType}
                                                onChange={e => onFilterChange("dateType", e.target.value)}
                                            >
                                                <option value={""}>...</option>
                                                <option value={"Issue"}>Issue Date</option>
                                                <option value={"Surveillance1"}>Surveillance 1</option>
                                                <option value={"Surveillance2"}>Surveillance 2</option>
                                                <option value={"Expiry"}>Expiry Date</option>
                                            </select>
                                        </Col>
                                        <Col xxl={2} md={12}>
                                            <Flatpickr className="form-control"
                                                value={filter.dateValue}
                                                onChange={(selectedDates, dateStr) => onFilterChange("dateValue", selectedDates)}
                                                options={{
                                                    enableTime: false,
                                                    mode: "range",
                                                    dateFormat: "m/d/Y"
                                                }}
                                            />
                                        </Col>
                                        <Col xxl={2} md={12}>
                                            <button type="button" className="btn btn-primary btn-label w-100" 
                                                disabled={loading}
                                                onClick= {() => doSearch()}
                                            >
                                                <i className="ri-search-eye-line label-icon align-middle"></i> Search
                                            </button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardLoader loading={loading} />
                                <CardBody>
                                    <div className="table-responsive table-card">
                                        <Table className="table-hover align-middle mb-0">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th style={{width:10}}>&nbsp;</th>
                                                    <th>Ticket #</th>
                                                    <th>Status</th>
                                                    <th>Certificate #</th>
                                                    <th>Accreditation Type</th>
                                                    <th>Country</th>
                                                    <th>Customer Name</th>
                                                    <th>Certified Company Name</th>
                                                    <th>Standard Name</th>
                                                    <th>Certificate Date</th>
                                                    <th>Surveillance 1</th>
                                                    <th>Surveillance 2</th>
                                                    <th>Certificate Expiry</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list.dataList.map(function(item, index){
                                                    return(
                                                        <tr key={index}>
                                                            <td>
                                                                <div className="flex-shrink-0">
                                                                    <ul className="list-inline tasks-list-menu mb-0">
                                                                        <li className="list-inline-item">
                                                                            <Link to={`/iso-certificate-edit/${item.id}`}>
                                                                                <i className="ri-pencil-fill fs-20 align-bottom text-primary"></i>
                                                                            </Link>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                            <td style={{whiteSpace: "nowrap"}}>
                                                                <NavLink  to={`/iso-request-edit/${item.requestId}`}>{item.requestNumber}</NavLink>
                                                            </td>
                                                            <td><span className="badge" style={{backgroundColor: item.requestStatusColorCode}}>{item.requestStatusName}</span></td>
                                                            <td>{item.certificateNumber}</td>
                                                            <td>{item.accreditationType}</td>
                                                            <td>{item.countryName}</td>
                                                            <td>
                                                                {item.customerName}
                                                                <CustomerCategoryLabel value={item.customerCategory || ""} />
                                                            </td>
                                                            <td>{item.certifiedCustomerName}</td>
                                                            <td>{item.standardShortName}</td>
                                                            <td className={item.isStartDatePassed ? "strike-text" : ""}><MyDateRenderer value={item.certificateIssueDate} format="mm/dd/yyyy" /></td>
                                                            <td className={item.isSurveillance1DatePassed ? "strike-text" : ""}>{item.isUnaccredited ? "N/A" : <MyDateRenderer value={item.surveillance1Date} format="mm/dd/yyyy" />}</td>
                                                            <td className={item.isSurveillance2DatePassed ? "strike-text" : ""}>{item.isUnaccredited ? "N/A" : <MyDateRenderer value={item.surveillance2Date} format="mm/dd/yyyy" />}</td>
                                                            <td className={item.isExpiryDatePassed ? "strike-text" : ""}><MyDateRenderer value={item.certificateExpiryDate} format="mm/dd/yyyy" /></td>
                                                            <td>{item.certificateStatus}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <Row>
                                        <Col lg={12}>
                                            <PaginationComponent
                                                total={list.totalCount}
                                                currentPage={filter.pageIndex}
                                                onPageChange={page => onPageChange(page)}
                                                onExportToExcel={() => exportToExcel()}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </Fragment>
    );
}

export default IsoRequestNotifySearchScreen;